const renderedParticipants = new Set();

export async function renderRegistrationListIncremental(
  apiUrl,
  containerSelector
) {
  try {
    const container = document.querySelector(containerSelector);
    if (!container) {
      console.error('Container not found:', containerSelector);
      return null;
    }

    const response = await fetch(apiUrl);
    if (!response.ok) {
      throw new Error(`API error: ${response.status}`);
    }

    const data = await response.json();

    data.entries.forEach((item) => {
      let progressPercent = null;
      let targetText = item.target
        ? `z ${parseFloat(item.target).toLocaleString()} zł`
        : ``;
      let startPercent = 10;
      if (item.target)
        progressPercent = item.target
          ? Math.min(
              (parseFloat(item.current) / parseFloat(item.target)) * 100,
              100
            )
          : 0;
      else progressPercent = 100;
      if (progressPercent > 20) {
        startPercent = progressPercent / 2;
      }
      if (progressPercent > 50) {
        startPercent = 50;
        targetText = ``;
      }
      const itemHtml = `
<div class="registration-list__filter-list--item">
    <div class="registration-list__filter-list--item-bar">
        <div>
            <p class="registration-list__filter-list--title">${item.name}</p>
            <p class="is-style-tag ${!item.nr ? 'null' : ''}">
            ${window.sygnisoft_i18n.startingNr}
            ${item.nr ? `<span>${item.nr}</span>` : '-'}
            </p>
        </div>
        <div class="registration-list__filter-list--logo">
            ${item.img2 ? `<img src="${item.img2}" alt="Logo">` : ''}
        </div>
    </div>
    <div class="registration-list__filter-list--image">
        <img src="${item.img1}" alt="registration image">
    </div>
    <div class="registration-list__filter-list--item-bottom">
        <div class="progress-bar" style="margin-top: 16px">
            <span class="bar" style="width: ${progressPercent}%"></span>
            <span class="point-text start" style="left: ${startPercent}%">${parseFloat(
        item.current
      ).toLocaleString()} zł</span>
            <span class="point-text target">${targetText}</span>
        </div>
        <a class="wp-block-button__link wp-element-button" target="_blank"
           href="${item.url}">${window.sygnisoft_i18n.readMore}</a>
    </div>
</div>
`;
      container.insertAdjacentHTML('beforeend', itemHtml);
      renderedParticipants.add(item.nr);
    });

    console.log(data.pagination);

    return {
      totalPages: data.pagination.totalPages || 1,
      currentPage: data.pagination.currentPage || 1,
      total: data.stats?.total || 0,
      entries: data.entries || [],
    };
  } catch (error) {
    console.error('Error rendering registration list:', error);
    return null;
  }
}

export function clearRenderedParticipants(containerSelector) {
  const container = document.querySelector(containerSelector);
  container.innerHTML = '';
  renderedParticipants.clear();
}
